import { render, staticRenderFns } from "./SalarySampleUpdate.vue?vue&type=template&id=d05c0a6c&scoped=true"
import script from "./SalarySampleUpdate.vue?vue&type=script&lang=js"
export * from "./SalarySampleUpdate.vue?vue&type=script&lang=js"
import style0 from "./SalarySampleUpdate.vue?vue&type=style&index=0&id=d05c0a6c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05c0a6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d05c0a6c')) {
      api.createRecord('d05c0a6c', component.options)
    } else {
      api.reload('d05c0a6c', component.options)
    }
    module.hot.accept("./SalarySampleUpdate.vue?vue&type=template&id=d05c0a6c&scoped=true", function () {
      api.rerender('d05c0a6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeSalary/SalarySampleUpdate.vue"
export default component.exports